import { HttpInterceptorFn } from '@angular/common/http';
import { TERMINVEREINBARUNG_REQUEST } from '@mobi/dip-terminvereinbarung-jslib';
import { environment } from '@src/environments/environment';

export const terminvereinbarungBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.context.get(TERMINVEREINBARUNG_REQUEST)) {
    return next(req);
  }

  // Only prepend for relative URLs.
  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }

  const baseUrl = environment.terminvereinbarungBaseUrl.replace(/\/$/, '');
  const path = req.url.replace(/^\//, '');

  return next(req.clone({ url: `${baseUrl}/${path}` }));
};
